<template>
  <div
    class="d-flex align-items-center justify-content-start flex-wrap mt-5 add-image"
  >
    <div class="col-5">
      <input
        :class="`img-downloader-${this.type}`"
        type="file"
        multiple
        data-allowed-file-extensions="jpg png jpeg"
        @change="(e) => selectImage(e, type)"
      />
      <div v-if="fileSelected" class="rotate-section">
        <img
          src="/static/assets/images/rotate-left.png"
          @click="rotateImg('left', type)"
          alt="rotate-left"
        />
        <img
          src="/static/assets/images/rotate-right.png"
          @click="rotateImg('right', type)"
          alt="rotate-right"
        />
      </div>
    </div>
    <div class="form-group form-material col-5">
      <label
        class="control-label"
        :for="`${type}-name`"
        v-if="type !== 'slider'"
      >
        {{ $t("input.name") }}
      </label>
      <input
        v-if="type !== 'slider'"
        type="text"
        class="form-control"
        @input="(e) => handleLabelChange(type, e.target.value)"
        :id="`${type}-name`"
        :value="value"
      />
    </div>
    <div class="col-2">
      <button
        type="button"
        class="btn btn-primary waves-effect waves-classic btn-save"
        :disabled="disableAddImage"
        @click="addImage(type)"
      >
        {{ $t("button.add") }}
      </button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  name: "ImageUploader",
  data() {
    return {
      messages: {
        default: "",
        replace: "Drag and drop or click to replace",
        remove: "Remove",
        error: "Ooops, something wrong happened.",
      },
    };
  },
  props: [
    "addImage",
    "rotateImg",
    "fileSelected",
    "handleLabelChange",
    "amenity",
    "selectImage",
    "type",
    "value",
    "lang",
    "disableAddImage",
  ],
  mounted() {
    if (Vue.config.lang === this.lang) {
      this.setMessages();
    }
  },
  watch: {
    lang: function (val) {
      Vue.config.lang = val;
      this.setMessages();
    },
  },
  methods: {
    setMessages() {
      this.messages.default = this.$t("drag_and_drop_file");
      $(`#${this.type} .img-downloader-${this.type}`).dropify({
        messages: this.messages,
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// ImageUploader.vue?589beef8